import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editServerDialog from '../dialog.editServerDialog';
import controller from './server.controller';
import directive from './server.directive';


export default angular.module('app.components.advisory.bcp.server', [
  alerts,
  bcpDataService,
  confirmDialog,
  constants,
  editServerDialog,
  ssDialogService,
])
  .directive('bcpServer', directive)
  .controller('ServerController', controller)
  .name;

console.log('app.components.advisory.bcp.server created');
